import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, message, Modal, Popconfirm, Row, Spin, Upload } from "antd";
import { DeleteOutlined, FileOutlined, FilePdfOutlined, InboxOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  startLoadCampaniaMateriales,
  startDeleteCampaniaMaterial,
  startPostCampaniaMaterial,
} from "../../../../context/actions/campaniasActions";
import CardPage from "../../../../layout/CardPage";

export default function MaterialesCampania() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { clienteID, campaniaID } = useParams();
  const [descripcion, setDescripcion] = useState("");
  const [materialSeleccionado, setMaterialSeleccionado] = useState(null);
  const { campaniaMateriales } = useSelector((state) => state.campaniasReducer);
  const { email } = useSelector((state) => state.userReducer.user);
  const {
    deletingCampaniaMaterial,
    loadingCampaniaMateriales,
    uploadingCampaniaMaterial,
  } = useSelector((state) => state.loadingReducer);
  const puedeEliminarMaterial = email === "pat9000@hotmail.com";

  useEffect(() => {
    dispatch(startLoadCampaniaMateriales(campaniaID));
  }, [dispatch, campaniaID]);

  const handleRegresar = () =>
    history.push(`/clientes/detalleCampania/${clienteID}/${campaniaID}`);

  const beforeUpload = () => {
    if (descripcion.trim()) return true;
    message.error("Capture la descripcion del material");
    return Upload.LIST_IGNORE;
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    const result = await dispatch(
      startPostCampaniaMaterial({ campaniaID, descripcion, file })
    );

    if (result.success) {
      setDescripcion("");
      onSuccess(result.data);
    } else {
      onError(new Error(result.error || "Error al cargar material"));
    }
  };

  const handleEliminarMaterial = (event, material) => {
    event?.stopPropagation();
    dispatch(
      startDeleteCampaniaMaterial({
        materialID: material.id,
        campaniaID,
      })
    );
  };

  return (
    <CardPage
      titulo="Materiales de campaña"
      tituloBoton="Regresar"
      accionBoton={handleRegresar}
    >
      <div style={{ maxWidth: 650 }}>
        <Input
          placeholder="Descripcion"
          value={descripcion}
          onChange={({ target }) => setDescripcion(target.value)}
          style={{ marginBottom: 12 }}
        />

        <Upload.Dragger
          beforeUpload={beforeUpload}
          customRequest={customRequest}
          disabled={!descripcion.trim() || uploadingCampaniaMaterial}
          multiple
          showUploadList={false}
          style={{ marginBottom: 20 }}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            {descripcion.trim()
              ? "Cargar material"
              : "Capture la descripción para cargar material"}
          </p>
        </Upload.Dragger>

        {loadingCampaniaMateriales && (
          <div style={{ textAlign: "center" }}>
            <Spin />
          </div>
        )}

        {!loadingCampaniaMateriales && (
          <Row gutter={[12, 12]}>
            {campaniaMateriales.map((material) => (
              <Col xs={24} sm={12} md={8} key={material.id || material.url}>
                <Card
                  actions={
                    puedeEliminarMaterial
                      ? [
                          <Popconfirm
                            cancelText="Cancelar"
                            key="delete"
                            okButtonProps={{ loading: deletingCampaniaMaterial }}
                            okText="Eliminar"
                            onCancel={(event) => event?.stopPropagation()}
                            onConfirm={(event) => handleEliminarMaterial(event, material)}
                            title="¿Eliminar material?"
                          >
                            <Button
                              danger
                              disabled={deletingCampaniaMaterial}
                              icon={<DeleteOutlined />}
                              loading={deletingCampaniaMaterial}
                              onClick={(event) => event.stopPropagation()}
                              type="text"
                            >
                              Eliminar
                            </Button>
                          </Popconfirm>,
                        ]
                      : undefined
                  }
                  hoverable
                  onClick={() => setMaterialSeleccionado(material)}
                  size="small"
                  cover={
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        height: 130,
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      {esImagen(material.url) ? (
                        <img
                          alt={material.descripcion}
                          src={material.url}
                          style={{
                            height: "100%",
                            objectFit: "cover",
                            width: "100%",
                          }}
                        />
                      ) : esPdf(material.url) ? (
                        <FilePdfOutlined style={{ color: "#ca2228", fontSize: 34 }} />
                      ) : (
                        <FileOutlined style={{ fontSize: 34 }} />
                      )}
                    </div>
                  }
                  style={{ height: "100%" }}
                >
                  <Card.Meta title={material.descripcion} />
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
      <Modal
        footer={null}
        onCancel={() => setMaterialSeleccionado(null)}
        open={!!materialSeleccionado}
        title={materialSeleccionado?.descripcion}
        width="80%"
      >
        {materialSeleccionado && esImagen(materialSeleccionado.url) ? (
          <img
            alt={materialSeleccionado.descripcion}
            src={materialSeleccionado.url}
            style={{ maxHeight: "75vh", objectFit: "contain", width: "100%" }}
          />
        ) : materialSeleccionado ? (
          <iframe
            src={getPdfViewerUrl(materialSeleccionado.url)}
            style={{ border: 0, height: "75vh", width: "100%" }}
            title={materialSeleccionado.descripcion}
          />
        ) : null}
      </Modal>
    </CardPage>
  );
}

const esImagen = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url || "");
const esPdf = (url) => /\.pdf$/i.test(url || "");
const getPdfViewerUrl = (url) =>
  `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`;
